import { css } from '@emotion/react'
import { colors, spacing } from 'styles/variables'

export const cardContainer = css`
  background-color: rgba(255, 255, 255, 0.08);
  border-radius: ${spacing(3)};
  padding: ${spacing(3)};
  margin-bottom: ${spacing(2)};
  border: 1px solid rgba(255, 255, 255, 0.1);
`

export const cardContent = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(2.5)};
`

export const topSection = css`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

export const leftSection = css`
  flex: 1;
`

export const rightSection = css`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${spacing(1.5)};
  margin-top: ${spacing(3)};
`

export const teamsContainer = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(1.5)};
`

export const teamRow = css`
  display: flex;
  align-items: center;
  gap: ${spacing(2)};
`

export const teamLogoContainer = css`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const teamLogo = css`
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 50%;
`

export const teamBadge = css`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #FFD700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const losingTeamBadge = css`
  background-color: #FF4444;
`

export const teamText = css`
  color: #ffffff;
  font-weight: 700;
  line-height: 1;
  font-size: 12px;
`

export const teamStatusContainer = css`
  display: flex;
  align-items: center;
  gap: ${spacing(1)};
`

export const teamNameText = css`
  color: #ffffff;
  font-weight: 700;
`

export const teamStatusText = css`
  font-weight: 700;
  margin-left: ${spacing(4)};
`

export const winsText = css`
  color: #ffffff;
`

export const losesText = css`
  color: #999999;
`

export const customEventContainer = css`
  display: flex;
  align-items: center;
  gap: ${spacing(2)};
`

export const customEventIcon = css`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
`

export const customEventText = css`
  flex: 1;
`

export const customDescription = css`
  color: ${colors.white80};
  font-weight: 500;
`

export const statusText = css`
  line-height: 1;
  font-weight: 600;
`

export const amountText = css`
  color: ${colors.white100};
  line-height: 1;
  font-weight: 700;
`

export const dateText = css`
  color: ${colors.white60};
  line-height: 1;
  font-weight: 500;
`

export const receiptSection = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(2)};
  padding-top: ${spacing(2)};
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`

export const receiptHeader = css`
  display: flex;
  align-items: center;
  gap: 0;
`

export const receiptLabel = css`
  color: ${colors.white60};
  text-transform: uppercase;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0.5px;
  font-size: 8px;
  margin-left: ${spacing(-4)};
`

export const receiptButtonsContainer = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(1.5)};
`

export const addressWarning = css`
  padding: ${spacing(1)};
  background-color: rgba(255, 193, 7, 0.1);
  border-radius: ${spacing(1)};
  border: 1px solid rgba(255, 193, 7, 0.3);
`

export const warningText = css`
  color: #ffc107;
  line-height: 1.3;
`

export const receiptButtons = css`
  display: flex;
  gap: ${spacing(2)};
`

export const receiptButton = css`
  flex: 1;
  padding: ${spacing(1.5, 2)};
  border-radius: 16px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:disabled {
    background-color: #6c757d !important;
    cursor: not-allowed;
  }
`

export const downloadButton = css`
  background-color: #4AC784;
  
  &:hover:not(:disabled) {
    background-color: #1E4C35;
  }
  
  &:active:not(:disabled) {
    background-color: #1E4C35;
  }
`

export const emailButton = css`
  background-color: #4AC784;
  
  &:hover:not(:disabled) {
    background-color: #1E4C35;
  }
  
  &:active:not(:disabled) {
    background-color: #1E4C35;
  }
`

export const buttonText = css`
  color: #000000;
  line-height: 1;
`

export const beneficiarySection = css`
  display: flex;
  align-items: center;
  gap: ${spacing(2)};
  padding-top: ${spacing(2)};
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`

export const beneficiaryIcon = css`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: rgba(111, 207, 151, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const beneficiaryLogo = css`
  width: 24px;
  height: 24px;
  border-radius: 50%;
`

export const beneficiaryLogoOnly = css`
  width: 32px;
  height: 32px;
  object-fit: contain;
  flex-shrink: 0;
`

export const beneficiaryInfo = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${spacing(0.75)};
`

export const beneficiaryLabel = css`
  color: ${colors.white60};
  text-transform: uppercase;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0.5px;
  font-size: 8px;
`

export const beneficiaryName = css`
  color: ${colors.white100};
  line-height: 1.3;
  font-weight: 600;
  font-size: 12px;
`

export const tournamentSection = css`
  display: flex;
  align-items: center;
  gap: ${spacing(2)};
`

export const tournamentIcon = css`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const tournamentLogo = css`
  width: 24px;
  height: 24px;
`

export const tournamentInfo = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${spacing(0.75)};
`

export const tournamentLabel = css`
  color: ${colors.white60};
  text-transform: uppercase;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0.5px;
  font-size: 8px;
`

export const tournamentName = css`
  color: ${colors.white100};
  line-height: 1.3;
  font-weight: 600;
  font-size: 12px;
`